import { render, staticRenderFns } from "./CampaignSetupPixelsEvents.vue?vue&type=template&id=80531260&"
import script from "./CampaignSetupPixelsEvents.vue?vue&type=script&lang=js&"
export * from "./CampaignSetupPixelsEvents.vue?vue&type=script&lang=js&"
import style0 from "./CampaignSetupPixelsEvents.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports